import axios from 'axios'
import { baseUrl } from '@/shared/constants'
import { ShopItemType } from './types'

export const getCases = async (token: string) => {
  const response = await axios.get(`${baseUrl}/lb/`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return response.data
}

export const getCaseContent = async (token: string, id: number) => {
  const response = await axios.get(`${baseUrl}/lb/contents?lootbox_id=${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return response.data
}

export const postPurchaseKey = async (token: string, key_id: number) => {
  const response = await axios.post(
    `${baseUrl}/payment/purchase-key`,
    {
      key_id: key_id,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )

  return response.data
}

export const getUniqueContent = async (token: string, id: number) => {
  const response = await axios.get(`${baseUrl}/lb/unique-content-status?lootbox_id=${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const postClaimDailyKey = async (token: string) => {
  const response = await axios.post(
    `${baseUrl}/lb/claim-key`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )

  return response.data
}

export const postOpenCase = async (token: string, id: number) => {
  const response = await axios.post(
    `${baseUrl}/lb/open`,
    {
      lootbox_id: id,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}

export const getKeysBundles = async (token: string): Promise<ShopItemType[]> => {
  const response = await axios.get(`${baseUrl}/lb/keys-bundles`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}
